
namespace TabAurous.Purchase{

    @Serenity.Decorators.registerClass()
    export class ApprovalInReturnLaborGrid extends Serenity.EntityGrid<ApprovalInReturnLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInReturnLabor'; }
        protected getIdProperty() { return ApprovalInReturnLaborRow.idProperty; }
        protected getInsertPermission() { return ApprovalInReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInReturnLaborRow.localTextPrefix; }
        protected getService() { return ApprovalInReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}